import React, { useState, useEffect } from "react";
import "../../components/AddMicrochip/AddMicrochip.css";

const AddMicrochip = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  return (
    <div className="container-fluid">
      <br />

      <div className="microchipDetail">
        <form className="microchip-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Product Name</td>
              <td>Price</td>
              <td>Status</td>
            </tr>

            <tr>
              <td>
                <input placeholder="Enter Please" />
              </td>
              <td>
                <input placeholder="Enter Please" />
              </td>
              <td>
                <input placeholder="Enter Please" />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addMicrochip-button">
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            <button
              type="submit"
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Save
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default AddMicrochip;
